import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearToast } from '../../store/slices/taxPlannerSlice';
import Toast from '../Toast';

// The one toast of SCR-02 (B-07): neutral, at the bottom centre, 2.6 s; the table and the DirtyBar both raise it.
function PlannerToast() {
  const dispatch = useDispatch();
  const message = useSelector((state) => state.taxPlanner.toast);
  const close = useCallback(() => dispatch(clearToast()), [dispatch]);
  if (!message) return null;
  return <Toast key={message} message={message} type="neutral" duration={2600} onClose={close} />;
}

export default PlannerToast;
